export default {
  company: null,
  companies: [],
  loading: false,
}
